export const tjenestePath: string = '?tjeneste=verktoy';

export const PARAM_RETUR_URL = 'retururl';
export const PARAM_RETUR_URL_TEKST = 'retururltekst';
